import React from 'react';

import {
  SearchItem,
  SearchLabelItem,
  SearchNewsItem,
  SearchCommentItem,
  PhotoParams,
} from '../SearchInput.types';

import { SearchOptionNews } from './SearchOptionNews';
import { SearchOptionComment } from './SearchOptionComment';
import { SearchOptionLabel } from './SearchOptionLabel';

interface SearchCommentOptionProps {
  option: SearchItem;
  loadPhoto: (params: PhotoParams) => Promise<Blob>;
}

export const SearchOption = ({
  option,
  loadPhoto,
}: SearchCommentOptionProps) => {
  switch (option.type) {
    case 'news':
      return (
        <SearchOptionNews
          option={option as SearchNewsItem}
          loadPhoto={loadPhoto}
        />
      );
    case 'comment':
      return (
        <SearchOptionComment
          option={option as SearchCommentItem}
          loadPhoto={loadPhoto}
        />
      );
    case 'label':
      return <SearchOptionLabel option={option as SearchLabelItem} />;
    default:
      return null;
  }
};
